import { getAntifraudNotifications } from '@/api/antifraud.js';
import constants from '@/constants';

export default {
    state: {
        notifications: [],
        pagination: {
            total: 0,
            limit: constants.PAGINATION.DEFAULT_LIMIT,
            offset: constants.PAGINATION.DEFAULT_OFFSET,
            count: 0,
        },
        links: {
            self: null,
            first: null,
            prev: null,
            next: null,
            last: null,
        },
        sortField: 'created_at:desc',
        isLoading: false,
    },

    getters: {
        ANTIFRAUD_NOTIFICATIONS: (state) => state.notifications,
        ANTIFRAUD_PAGINATION: (state) => state.pagination,
        ANTIFRAUD_LINKS: (state) => state.links,
        IS_ANTIFRAUD_LOADING: (state) => state.isLoading,

        // Computed values for PaginationController
        ANTIFRAUD_CURRENT_PAGE: (state) => {
            const { offset, limit } = state.pagination;
            return Math.floor(offset / limit);
        },
        ANTIFRAUD_TOTAL_PAGES: (state) => {
            const { total, limit } = state.pagination;
            return Math.max(0, Math.ceil(total / limit) - 1);
        },
        ANTIFRAUD_DISPLAY_RANGE: (state) => {
            const { offset, limit, total } = state.pagination;
            if (total === 0) return '0-0 of 0';
            const start = offset + 1;
            const end = Math.min(offset + limit, total);
            return `${start}-${end} of ${total}`;
        },
    },

    mutations: {
        SET_ANTIFRAUD_NOTIFICATIONS(state, payload) {
            state.notifications = payload;
        },
        SET_ANTIFRAUD_PAGINATION(state, payload) {
            state.pagination = payload;
        },
        SET_ANTIFRAUD_LINKS(state, payload) {
            state.links = payload;
        },
        SET_ANTIFRAUD_LOADING(state, payload) {
            state.isLoading = payload;
        },
        SET_ANTIFRAUD_LIMIT(state, payload) {
            state.pagination.limit = payload;
            state.pagination.offset = 0;
        },
        SET_ANTIFRAUD_OFFSET(state, payload) {
            state.pagination.offset = payload;
        },
        SET_ANTIFRAUD_SORT(state, payload) {
            state.sortField = payload;
            state.pagination.offset = 0;
        },
    },

    actions: {
        async loadAntifraudNotifications({ commit, state }) {
            commit('SET_ANTIFRAUD_LOADING', true);
            try {
                const params = {
                    limit: state.pagination.limit,
                    offset: state.pagination.offset,
                    sort: state.sortField,
                };

                const response = await getAntifraudNotifications(params);

                commit('SET_ANTIFRAUD_NOTIFICATIONS', response.data || []);
                commit(
                    'SET_ANTIFRAUD_PAGINATION',
                    response.pagination || {
                        total: 0,
                        limit: constants.PAGINATION.DEFAULT_LIMIT,
                        offset: 0,
                        count: 0,
                    }
                );
                commit('SET_ANTIFRAUD_LINKS', response.links || {});
            } catch (error) {
                console.error(
                    '[antifraud] Error loading notifications:',
                    error
                );
                commit('SET_ANTIFRAUD_NOTIFICATIONS', []);
                commit('SET_ANTIFRAUD_PAGINATION', {
                    total: 0,
                    limit: constants.PAGINATION.DEFAULT_LIMIT,
                    offset: 0,
                    count: 0,
                });
            } finally {
                commit('SET_ANTIFRAUD_LOADING', false);
            }
        },

        async changeAntifraudPage({ commit, dispatch }, pageAction) {
            const state = this.state.antifraud;
            const limit = state.pagination.limit;
            let newOffset = state.pagination.offset;

            switch (pageAction) {
                case 'first':
                    newOffset = 0;
                    break;
                case 'prev':
                    newOffset = Math.max(0, state.pagination.offset - limit);
                    break;
                case 'next':
                    newOffset = Math.min(
                        state.pagination.total - limit,
                        state.pagination.offset + limit
                    );
                    break;
                case 'last':
                    newOffset =
                        Math.floor((state.pagination.total - 1) / limit) *
                        limit;
                    break;
            }

            commit('SET_ANTIFRAUD_OFFSET', newOffset);
            await dispatch('loadAntifraudNotifications');
        },
    },
};
